export default {
  okText: '确认',
  closeText: '关闭',
  cancelText: '取消',
  loadingText: '加载中...',
  saveText: '保存',
  delText: '删除',
  resetText: '重置',
  searchText: '搜索',
  queryText: '查询',
  inputText: '请输入',
  chooseText: '请选择',
  redo: '刷新',
  back: '返回',
  light: '亮色主题',
  dark: '黑暗主题',
  edit: "编辑",
  fullScreen: "全屏",
  exitfullScreen: "退出全屏",
  LockScreen: "锁屏",
  ExitSystem: "退出系统",
  changeLuaguage: "切换语言",
  Loading: "加载中，请稍后...",
  SaveSuccess: "保存成功",
  DelSuccess: "删除成功"

};
